<mat-tab-group [(selectedIndex)]="selectedIndex">
  <mat-tab label="TATTA Admin Console">
    <app-help-admin *ngIf="selectedIndex === 0"></app-help-admin>
  </mat-tab>

  <mat-tab label="TATTA">
    <app-help-client *ngIf="selectedIndex === 1"></app-help-client>
  </mat-tab>
</mat-tab-group>
